const LazyRefreshConstants = {
    LAZY_REFRESH_START: 'LAZY_REFRESH_START',
    LAZY_REFRESH_REQUESTED: 'LAZY_REFRESH_REQUESTED',
    LAZY_REFRESH_DEAL_RECEIVED: 'LAZY_REFRESH_DEAL_RECEIVED',
    LAZY_REFRESH_COMPLETED: 'LAZY_REFRESH_COMPLETED',
    LAZY_REFRESH_TIMEOUT: 'LAZY_REFRESH_TIMEOUT',
    LAZY_REFRESH_FAILED: 'LAZY_REFRESH_FAILED',
    TRIGGER_POPUP: {
        DEAL_CHANGED: 'deal_changed',
        RATE_UNAVAILABLE: 'rate_unavailable',
    },
};

export default LazyRefreshConstants;
